<div class="container">
  <div class="category">
    <h4> <img [src]="'assets/img/'+healthTypes.icon+'.svg'" alt="icon"> {{ healthTypes.type | translation }} </h4>
    <div class="filter" *ngFor="let value of healthTypes.values">
      <button [disabled]="isFreemium" [ngClass]="{ 'selected': selected.filter === value.type }" mat-stroked-button
        (click)="getDataFromType(healthTypes.type, value.type)">{{ value.type | translation }}</button>
    </div>
  </div>
</div>